<template>
    <div v-if="show" class="modal fade show d-block" tabindex="-1">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Documentos</h5>
                    <button type="button" class="btn-close" @click="$emit('close')" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <!-- Tabla de Archivos -->
                    <div class="mt-4">
                        <table class="table table-font-small">
                            <thead class="table-light padding-custom">
                                <tr>
                                    <th>Tipo de Documento</th>
                                    <th>Estado</th>
                                    <th>Archivo</th>
                                    <th>Comentario</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody class="table-border-bottom-0 padding-custom">
                                    <tr v-for="archivo in archivos" :key="archivo.id || archivo.nombre">
                                    <td>{{ archivo.tipo }}</td>
                                    <td class="p-1">
                                        <span :class="getBadgeClass(archivo.id_estados_envio)">
                                            {{ archivo.estado }} 
                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="esImagen(archivo.nombre)">
                                            <img :src="archivo.url" class="img-thumbnail" width="50" />
                                        </span>
                                        {{ archivo.nombre }}
                                    </td>
                                    <td>{{ archivo.comentario }}</td>
                                    <td>
                                        <button class="btn btn-info btn-sm me-2" @click="$emit('ver', archivo)">
                                            <i class="bi bi-eye"></i> Ver
                                        </button>
                                            <button v-if="esSuperAdmin()" class="btn btn-danger btn-sm" @click="onEliminarClick(archivo)">
                                            <i class="bi bi-trash"></i> Eliminar
                                        </button>
                                    </td>
                                </tr>
                                <tr v-if="archivos.length === 0">
                                    <td colspan="5" class="text-center text-muted">
                                        No hay archivos subidos
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModalArchivos',
    props: {
        show: Boolean,
        archivos: Array
    },
    methods: {
        esImagen(nombre) {
            if (!nombre) { return }
            const extensiones = ['jpg', 'jpeg', 'png', 'gif', 'webp']
            const ext = nombre.split('.').pop().toLowerCase()
            return extensiones.includes(ext)
        },
        getBadgeClass(estadoId) {
            switch (estadoId) {
                case 1:
                    return 'badge bg-success'
                case 2:
                    return 'badge bg-warning text-dark'
                case 3:
                    return 'badge bg-danger'
                default:
                    return 'badge bg-secondary'
            }
        },
        
        esSuperAdmin() {
            const user = JSON.parse(localStorage.getItem('user'))
            return user?.cargo?.toLowerCase() === 'admin'
        },
        onEliminarClick(archivo) {
            const archivoId = archivo?.id ?? archivo?.id_archivo ?? archivo?.archivo_id ?? null
            console.log('ModalArchivos::archivo seleccionado para eliminar', archivo)
            console.log('ModalArchivos::id detectado', archivoId)
            this.$emit('eliminar', archivoId)
        }
    }
}
</script>
